export const initialValues = {
  name: "",
  email: "",
  // phone: "",
  customText: "",
};
